import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Doctors from './pages/Doctors';
import Forms from './pages/Forms';
import FormBuilder from './pages/FormBuilder';
import FormResponses from './pages/FormResponses';
import Prescriptions from './pages/Prescriptions';
import MetadataPage from './pages/Metadata';
import Metrics from './pages/Metrics';
import SchedulerSettingsPage from './pages/SchedulerSettings';
import PaymentRefundsPage from './pages/PaymentRefunds';
import Login from './pages/Login';
import CacheDebugger from './components/CacheDebugger';
import './styles/global.css';

const setFaviconFromText = (text: string) => {
  const canvas = document.createElement('canvas');
  canvas.width = 64;
  canvas.height = 64;
  const ctx = canvas.getContext('2d');
  if (ctx) {
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.font = 'bold 40px Inter, sans-serif';
    ctx.fillStyle = '#1976d2';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, canvas.width / 2, canvas.height / 2);
  }
  const url = canvas.toDataURL('image/png');
  let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = url;
};

const App: React.FC = () => {
  useEffect(() => {
    setFaviconFromText('SB');
  }, []);
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Layout>
                  <Users />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/doctors"
            element={
              <ProtectedRoute>
                <Layout>
                  <Doctors />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/forms"
            element={
              <ProtectedRoute>
                <Layout>
                  <Forms />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/forms/builder"
            element={
              <ProtectedRoute>
                <Layout>
                  <FormBuilder />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/forms/builder/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <FormBuilder />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/form-responses"
            element={
              <ProtectedRoute>
                <Layout>
                  <FormResponses />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/prescriptions"
            element={
              <ProtectedRoute>
                <Layout>
                  <Prescriptions />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/metadata"
            element={
              <ProtectedRoute>
                <Layout>
                  <MetadataPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/metrics"
            element={
              <ProtectedRoute>
                <Layout>
                  <Metrics />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/scheduler-settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <SchedulerSettingsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments/refunds"
            element={
              <ProtectedRoute>
                <Layout>
                  <PaymentRefundsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        
        {/* Cache Debugger - Only visible in development */}
        {process.env.NODE_ENV === 'development' && (
          <CacheDebugger isVisible={true} />
        )}
      </div>
    </Router>
  );
};

export default App; 